import * as React from 'react';
import { Provider } from 'react-redux';
import { i18n } from 'i18next';
import { I18nextProvider } from 'react-i18next';
import { ExperimentsProvider } from '@wix/wix-experiments-react';
import configureStore from './store-configuration';
import { Root } from '../../components/Root/Root';
import { AppState } from '../../reducers';

export interface Environment {
  i18n: i18n;
  experiments: any;
  initialState: Partial<AppState>;
}

export const wrapWithEnvironment =
  (environment: Environment) => (component: React.ReactElement) => {
    const store = configureStore({
      experiments: environment.experiments,
      initialState: environment.initialState,
      i18nData: environment.i18n,
    });

    return (
      <Provider store={store}>
        <I18nextProvider i18n={environment.i18n}>
          <ExperimentsProvider
            options={{ experiments: environment.experiments }}
          >
            <Root>{component}</Root>
          </ExperimentsProvider>
        </I18nextProvider>
      </Provider>
    );
  };
